// frontend/src/components/SampleRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface SampleRouteProps {
    children: React.ReactNode;
}

const SampleRoute: React.FC<SampleRouteProps> = ({ children }) => {
    const { user } = useAuthStore();

    // Verifica se o usuário tem permissão para acessar telas de amostras
    // Na AWS (ambiente de consultor), permitimos sempre para que possam preencher as fichas
    // Usamos a flag isAws vinda do backend (token) para garantir precisão
    const isAwsEnvironment = user?.isAws === true || process.env.REACT_APP_IS_AWS_ENV === 'true';

    const isAdmin = user?.role === 'admin' || user?.role === 'supervisor' || user?.role === 'diretor';

    if (!user || (user.usuarioAmostras !== 1 && !isAwsEnvironment && !isAdmin)) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default SampleRoute;
